module.exports = __webpack_public_path__ + "images/mdj/members/message/inboxdetail/inboxdetail_btn03-c1085d96aabc9420e4c5578aa935443e.jpg";